import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { userApi } from '@atheneum/api'
import Button from '@components/Button'

class ClientContactStatusChangeComment extends Component {
  static propTypes = {
    modalStore: PropTypes.object.isRequired,
    commentStore: PropTypes.object.isRequired,
    title: PropTypes.string,
    contact: PropTypes.object.isRequired,
    clientContactStore: PropTypes.object,
    growlStore: PropTypes.object
  }

  static defaultProps = {
    hideButtons: true,
    showCloseIcon: true,
    shouldCloseOnOverlayClick: false
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      statusChangeComment: '',
      isSubmitting: false
    })
  }

  toggleClientContactStatus = () => {
    const { commentStore, modalStore, clientContactStore, contact } = this.props
    this.isSubmitting = true

    const payload = {
      contactId: contact.id,
      commentPrefix: this.commentPrefix,
      comment: this.statusChangeComment
    }
    let promise
    if (contact.status === true) {
      promise = userApi.disableClientContact(payload)
    } else {
      promise = userApi.enableClientContact(payload)
    }

    promise
      .then(() => {
        const clientContactId = clientContactStore.contact.id

        commentStore.load(clientContactId, 'client').then(() => {
          modalStore.close()
          clientContactStore.getContact(clientContactId)
          this.isSubmitting = false
        })
      })
      .catch(err => {
        modalStore.close()
        this.props.growlStore.showError(err.message)
        this.isSubmitting = false
      })
  }

  render () {
    const wrapperClasses = classNames({
      'expert-form__input-wrapper': true
    })
    return (
      <div className='expert-form'>
        <h1 className='expert-form__title'>
          {this.props.title || 'Status change comment'}
        </h1>
        <div className='expert-form__input-group'>
          <label className='expert-form__label'>
            Add status change comment
          </label>
          <div className={wrapperClasses}>
            <div>
              <textarea
                onChange={e => (this.statusChangeComment = e.target.value)}
                value={this.statusChangeComment}
                className='expert-form__input'
                type='textarea'
                rows='5'
              />
            </div>
          </div>
        </div>
        <div className='expert-form__section p-b-0'>
          <div className='iconWrapper'>
            <Button
              primary
              submit
              onClick={() => this.toggleClientContactStatus()}
              disabled={!this.statusChangeComment || this.isSubmitting}
            >
              Save
            </Button>
          </div>
          <div className='inline m-l-lg'>
            <Button onClick={this.props.modalStore.close}>Cancel</Button>
          </div>
        </div>
      </div>
    )
  }
}

export default inject(
  'modalStore',
  'growlStore'
)(observer(ClientContactStatusChangeComment))
